import React from 'react';
import { motion } from 'framer-motion';
import { X, Clock } from 'lucide-react';
export function ProblemSection() {
  const failedAttempts = ['Los softwares de automatización eran demasiado complejos.', 'Los tutoriales te abrumaron con jerga técnica.', 'Las herramientas requerían semanas de configuración.'];
  return <section className="py-24 bg-[#141414] border-y border-white/5" data-id="element-155">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-156">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-157">
          <div className="inline-flex justify-center items-center w-16 h-16 rounded-full bg-red-500/10 text-red-500 mb-6" data-id="element-158">
            <Clock className="w-8 h-8" data-id="element-159" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-160">
            El Problema de la "Falta de Tiempo"
          </h2>
          <p className="text-xl text-gray-300 leading-relaxed" data-id="element-161">
            Cada día, pierdes tiempo valioso apagando fuegos: mensajes que
            llegan a las 11 de la noche, prospectos que se enfrían mientras
            buscas su información a mano, seguimientos que nunca se envían. Has
            intentado soluciones, pero:
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-162">
          {failedAttempts.map((attempt, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-center gap-4 p-6 rounded-xl bg-[#1A1A1A] border border-white/5" data-id="element-163">
              <div className="flex-shrink-0 w-8 h-8 rounded-full bg-red-500/10 flex items-center justify-center" data-id="element-164">
                <X className="w-5 h-5 text-red-500" data-id="element-165" />
              </div>
              <p className="text-lg text-gray-300" data-id="element-166">{attempt}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}